
import HCLTreeMxGraphEncoder from './HCLTreeMxGraphEncoder';
import BayesianNetworkMxGraph, { BayesianNetworkMxGraphJSON, BayesianNodeJSON } from '../HCLTreeMxGraph/BayesianNetworkMxGraph';
import ReferenceTypes from "../HCLTreeNode/HCLTreeVertexValue/ReferenceTypes";
import BayesianNetworkVertex from "../HCLTreeNode/BayesianNetworkNode/BayesianNetworkVertex";
import BayesianNetworkVertexValue from "../HCLTreeNode/BayesianNetworkNode/BayesianNetworkVertexValue";
import Outcome from "../HCLTreeNode/HCLTreeVertexValue/Outcome";
import {
  extractStates,
  generateTableData,
  transpose
} from "../../components/Model/SingleHCLModelView/SingleTreeView/Tools/Utils";

/**
 * Inherits from {@link HCLTreeMxGraphEncoder} and implements encoding for
 * {@link BayesianNetworkMxGraph}
 */
class BayesianNetworkMxGraphEncoder extends HCLTreeMxGraphEncoder {
  /**
   * @param {BayesianNetworkMxGraph} graph
   */
  constructor(graph: BayesianNetworkMxGraph) {
    // @ts-ignore
    super(graph);
  }

  /**
   * traverse all outgoing edges
   */
  traverseNodes = () => {
    const nodes: {[key: string]: BayesianNodeJSON} = {};
    (this.getGraph().getVertices() as BayesianNetworkVertex[]).map(vertex => {
      const value = vertex.getValue() as BayesianNetworkVertexValue;

      // update dependencies
      const dependencies = (vertex.getParents() as BayesianNetworkVertex[]).map(parent => {
        return new Outcome(parent.getKey(), ReferenceTypes.BAYESIAN_NODES, Number(parent.getGraph().getModelTreeId()), '').toJSON();
      });
      value.setDependencies(dependencies);

      // update states
      // @ts-ignore
      const [numRows, numCols, parents, targetStateNames, matrix] = generateTableData(this.getGraph() as BayesianNetworkMxGraph, vertex);
      const transposedMatrix = transpose(matrix);
      transposedMatrix.forEach(row => {
        if (parents.length < numCols && row[parents.length] === undefined) {
          row[parents.length] = 1;
          row.fill(0, parents.length + 1);
        }
      });
      value.setStates(extractStates(transposedMatrix, parents, targetStateNames, numRows, this.getGraph().getModelTreeId()));

      nodes[vertex.getKey()] = value.toJSON();
    });

    return nodes;
  };

  /**
   * @override
   * @return {BayesianNetworkMxGraphJSON}
   */
  encode = (): BayesianNetworkMxGraphJSON => {

    let json: BayesianNetworkMxGraphJSON  = {
      [ReferenceTypes.BAYESIAN_NODES]: {},
      name: this.getGraph().getTreeLabel().getName(),
      model_tree_id: this.getGraph().getModelTreeId(),
      label: this.getGraph().getTreeLabel().toJSON()
    };

    json.bayesian_nodes = this.traverseNodes();

    return json;
  };
}

export default BayesianNetworkMxGraphEncoder;
